import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoInstitucionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoInstitucionPage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoInstitucion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoInstitucion', name: 'TipoInstitucion', title: 'Tipo de Institución' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            tipoInstitucions: [],
            tipoInstitucion: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoInstitucion() {
            this.tipoInstitucion = {};
            this.$refs['frm-tipoInstitucion'].show();
        },
        showTipoInstitucion(id) {
            this.isLoading=true;
            this.ss.showTipoInstitucion(id).then(
                (result) => {
                    let response = result.data;
                    this.tipoInstitucion = response.data;
                    this.$refs['view-tipoInstitucion'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoInstitucion() {
            this.$refs['frm-tipoInstitucion'].show();
            this.$refs['view-tipoInstitucion'].hide();
        },
        cancelTipoInstitucion() {
            if (this.tipoInstitucion.id) {
                this.$refs['view-tipoInstitucion'].show();
            }
            this.$refs['frm-tipoInstitucion'].hide();
        },
        saveTipoInstitucion() {
            this.ss.storeTipoInstitucion(this.tipoInstitucion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipoInstitucion'].hide();
                    this.$refs['datatable-tipoInstitucion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoInstitucion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyTipoInstitucion(this.tipoInstitucion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipoInstitucion'].hide();
                                this.$refs['datatable-tipoInstitucion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoInstitucion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoInstitucion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }
    }
};
